var isPage = "";
var Block = {
	top: 0,
	show: 0,
	id: ""
}
var blocks = [];

var Video = {
	isPlaying: false,
	id: "",
	canPlay: false
}
var videos = [];
var players = [
	{
		isPlaying: false,
		id: "set0",
		canPlay: false,
		hasSP: true
	},
	{
		isPlaying: false,
		id: "set1",
		canPlay: false,
		hasSP: true
	},
	{
		isPlaying: false,
		id: "set2",
		canPlay: false,
		hasSP: true
	},
	{
		isPlaying: false,
		id: "trial0",
		canPlay: false,
		hasSP: true
	},
	{
		isPlaying: false,
		id: "feature0",
		canPlay: false,
		hasSP: false
	},
	{
		isPlaying: false,
		id: "feature1",
		canPlay: false,
		hasSP: false
	},
	{
		isPlaying: false,
		id: "feature2",
		canPlay: false,
		hasSP: false
	},
	{
		isPlaying: false,
		id: "feature3",
		canPlay: false,
		hasSP: false
	},
	{
		isPlaying: false,
		id: "feature4",
		canPlay: false,
		hasSP: false
	},
	{
		isPlaying: false,
		id: "trial1",
		canPlay: false,
		hasSP: true
	}
];
var service = {
	beforeW: 0,
	init: ()=>{
		var resizeFlag;
		var resizeTimer = null;
		var $body = $("body");
		common.resize();
		if(isSP){
			$(".wrap_movie.pc").remove();
		}
		setTimeout(function(){
			$("#main").addClass("active");
		}, 600);
		service.resize();
		setTimeout(function(){
			comment.init();
		}, 200);
		setInterval(function(){
			service.resize();
		}, 200);
		$(document).off("scroll touchmove").on("scroll touchmove", function(){
			service.scrl();
		});
	},
	resize: ()=>{
		var winW = window.innerWidth;
		var winH = window.innerHeight;
		var $body = $("body");
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		if(isSmallScreen){
			service.beforeW = 0;
			resizeBlocks()
			if(winW != common.beforeW){
				
			}
		}else{
			resizeBlocks()
		}
		
		function resizeBlocks(){
			blocks = [];
			$("#service section").each(function(i){
				let $this = $(this),
					_h = 0;
				if( $this.attr("data-name") === "set0" || $this.attr("data-name") === "set1" || $this.attr("data-name") === "set2" || $this.attr("data-name") === "feature"){
					if(isSmallScreen){
						//console.log( $this.attr("data-name"), $("#" +$this.attr("data-name") ).outerHeight())
						if( $this.attr("data-name") === "set0" || $this.attr("data-name") === "set1" ){
							$this.css({
								"height":  Math.floor( $("#" + $this.attr("data-name") ).outerHeight()*1.25 ) + "px"
							});
						}else if($this.attr("data-name") === "set2"){
							let blk = $("#" + $this.attr("data-name"));
							let movieH = blk.find(".img_main").outerHeight();
							let contentH = blk.find(".content").outerHeight();
							//console.log(movieH, contentH, movieH + contentH);
							$this.css({
								"height":  Math.floor( $("#" + $this.attr("data-name") ).outerHeight()) + "px"
							});
						}else{
							let h = $("#" +$this.attr("data-name") ).outerHeight();
							if(h < $(window).height() ){
								h = $(window).height();
							}
							$this.css({
								"height":  Math.floor( h ) + "px"
							});
						}
					}else{
						$this.css({
							"height":  Math.floor( $("#" +$this.attr("data-name") ).outerHeight() ) + "px"
						});
					}
				}
			});
			$("#service section").each(function(i){
				let $this = $(this);
				if( $this.attr("id") === "set0" || $this.attr("id") === "set1" || $this.attr("id") === "set2"){

				}else{
					let _b 	= object(Block);
					_b.id 	= $(this).attr("id");
					if(_b.id === "space0"){
						_b.top 	= Math.floor($this.offset().top);
						_b.show = Math.floor( _b.top/1.25 + $(window).height()/2 );
					}else if(_b.id === "space1" || _b.id === "space2"){
						_b.top 	= Math.floor($this.offset().top);
						_b.show = Math.floor( _b.top/1.2 + $(window).height()/2 );
					}else{
						_b.top 	= Math.floor($this.offset().top);
						_b.show = Math.floor( _b.top + $(window).height()/2 );
					}

					blocks.push(_b);
					if(_b.id === "space_feature"){
						$(".feature").each(function(i){
							let $this = $(this);
							let _b 	= object(Block);
							if(isSmallScreen){
								if( $html.classList.contains("active_feature") ){
									_b.top 	= Math.floor($this.offset().top);
								}else{
									_b.top 	= Math.floor($this.offset().top + blocks[6].top);
								}
							}else{
								_b.top 	= Math.floor($this.offset().top);
							}
							
							_b.show = Math.floor( _b.top + $(window).height()/3 );
							_b.id 	= $(this).attr("id");
							blocks.push(_b);
						});
					}
				}
				//console.log(blocks);
			});
		}
		
		
		if(!isSmallScreen){
			for(var i = 0; i < 3; i++){
				$("#set" + i).css({
					"top": blocks[i+1].top + "px"
				});
			}
			$("#feature").css({
				"top": blocks[6].top + "px"
			});
		}
		common.beforeW = winW;
		//console.log(blocks)
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},300);
	},
	scrollToPosition: (id,callback) =>{
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic",
			flag 	= true;
		$page.animate({
			scrollTop : "0px"
		},{
			"duration" 	: 1000,
			"easing" 	: ease,
			"complete"	: function(){
				if(flag){
					flag = false;
				}
			}
		});
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height(),
			showPoint = window.innerHeight;
		if(!isSmallScreen){
			showPoint = window.innerHeight/2;
		}
		if(topD >= showPoint){
			if( !$html.classList.contains("scrolled") ){
				$html.classList.add("scrolled")
			}
		}else{
			if( $html.classList.contains("scrolled") ){
				$html.classList.remove("scrolled");
			}
		}

		for(var i = 0; i < blocks.length; i++){
			if(i === blocks.length-1){

			}else{
				if(btmD >= blocks[i].show){
					activeBlock(i);
				}
			}
		}
		if(isSmallScreen){
			for(var j = 0; j < 3; j++){
				if(topD >= blocks[j+1].top){
					if( !$html.classList.contains("active_set" + j) ){
						$html.classList.add("active_set" + j);
						$("#set" + j).css({
							"top": blocks[j+1].top + "px"
						});
					}
				}else{
					if( $html.classList.contains("active_set" + j) ){
						$html.classList.remove("active_set" + j);
						$("#set" + j).css({
							"top": ""
						});
					}
				}
			}
			if(topD >= blocks[6].top){
				if( !$html.classList.contains("active_feature") ){
					$html.classList.add("active_feature");
					$("#feature").css({
						"top": blocks[6].top + "px"
					});
					common.resize();
				}
			}else{
				if( $html.classList.contains("active_feature") ){
					$html.classList.remove("active_feature");
					$("#feature").css({
						"top": ""
					});
					common.resize();
				}
			}
		}
		
		function activeBlock(i){
			let $b = $("#" + blocks[i].id);
			if(	!$b.hasClass("active") ){
				$b.addClass("active");

				let name = $b.attr("data-name");
				if(name === "set0" || name === "set1" || name === "set2" || name === "feature"){
					$("#" + name).addClass("active");
					setTimeout(function(){
						$("#" + name).find(".link_arrow .arrow").addClass("animated");
					}, 1000);
				}
				
				let $video_pc;
				let $video_sp;
				let $video;
				let hasVideo = false;
				let hasSP = false;
				/*
					スマホ用のvideoがある場合とない場合があるので、分岐
					playersの配列を参照
				*/
				for(var j = 0; j < players.length; j++){
					if(name === players[j].id){
						let p = players[j];
						if(!p.isPlaying){
							if(p.hasSP){
								hasVideo = true;
								hasSP = true;
								$video_sp = $("video#" + name + "_sp");
								if(isSmallScreen){
									
								}else{
									$video_pc = $("video#" + name + "_pc");
								}
							}else{
								hasVideo = true;
								hasSP = false;
								$video = $("video#" + name);
							}
						}
					}
				}
				if(hasVideo){
					if(hasSP){
						$video_sp[0].play();
						if(!isSmallScreen){
							$video_pc[0].play();
						}
					}else{
						$video[0].play();
					}
					
				}
			}
		}
	},
	returnVisible: function(){
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height();

		for(var i = 0; i < blocks.length; i++){
			if(i === blocks.length-1){

			}else{
				if(btmD >= blocks[i].show){
					activeBlock(i);
				}
			}
		}
		
		function activeBlock(i){
			let $b = $("#" + blocks[i].id);
			let name = $b.attr("data-name");
			let $video_pc;
			let $video_sp;
			let $video;
			let hasVideo 	= false;
			let hasSP 		= false;
			/*
				スマホ用のvideoがある場合とない場合があるので、分岐
				playersの配列を参照
			*/
			for(var j = 0; j < players.length; j++){
				if(name === players[j].id){
					let p = players[j];
					if(!p.isPlaying){
						if(p.hasSP){
							hasVideo = true;
							hasSP = true;
							$video_sp = $("video#" + name + "_sp");
							if(isSmallScreen){
								
							}else{
								$video_pc = $("video#" + name + "_pc");
							}
						}else{
							hasVideo = true;
							hasSP = false;
							$video = $("video#" + name);
						}
					}
				}
			}
			if(hasVideo){
				if(hasSP){
					let ctime = $video_sp[0].currentTime;
					setTimeout(function(){
						//console.log(ctime,$video_sp[0].currentTime)
						if($video_sp[0].currentTime === ctime){
							$video_sp[0].play();
							if(!isSmallScreen){
								$video_pc[0].play();
							}
						}
					},100);
				}else{
					$video[0].play();
				}
				
			}
		}
	}
}